import React from 'react';
import { MasterPage } from 'src/components/common/template/master-page';
import FootBallHome from './football-home';

//helpers
import { useStores } from 'src/utils/useStore';
import { getDeviceImage } from 'src/components/common/theme/component';
import { SubHeaderProps } from 'src/components/common/modules/global-header/global-header.d';

import { FootballPageProps } from 'src/components/spotlight/module-util';
import { checkValue } from 'src/components/common/helper';

const FootballHub: React.FC<FootballPageProps> = (props) => {
  const {
    cpcmslitefeed: { cpCmsLitePageData },
  } = useStores();

  const {
    partnerLogoAltText,
    partnerName,
    partnerLogo,
    partnerCtaText,
    partnerCtaUrl,
    partnerMessage,
    partnerUrl,
    socialModule,
    partnerHeaderBackgroundColor,
    partnerHeaderTextColor,
    partnerMessageUrl,
    partnerHeaderSize,
    partnerCtaColor,
    partnerHeaderPlaceholderText,
    partnerHeaderPlaceholderUrl,
    openPartnerUrlInSameTab,
    partnerCtaTextColor,
    partnerCtaHoverColor,
    partnerCtaHoverTextColor,
    partnerHeaderNavigation,
    primaryColour,
    secondaryColour,
    subHeaderHamburgerMenuIconColor,
    subHeaderHamburgerMenuBackgroundColor,
    subHeaderHamburgerMenuTextColor,
    subHeaderHamburgerMenuBackgroundHoverColor,
    subHeaderHamburgerMenuTextHoverColor,
    subHeaderHamburgerMenuBackgroundSelectedColor,
    lozengeMessage,
    lozengeDetailMessage,
    lozengeTextColor,
    lozengeBackgroundColor,
    lozengeIconColor,
    turnOffHeader,
    turnOffSubheader,
    turnOffSubHeaderHamburgerMenu,
  } = cpCmsLitePageData;

  const subHeaderProps: SubHeaderProps = {
    partnerLogoAltText,
    partnerName,
    partnerCtaText,
    partnerCtaUrl,
    partnerMessage,
    partnerUrl,
    partnerLogo: getDeviceImage(partnerLogo, 'desktop'),
    partnerHeaderBackgroundColor,
    partnerHeaderTextColor,
    partnerMessageUrl,
    variant: 'v1',
    progressbar: true,
    partnerHeaderSize:checkValue(partnerHeaderSize) ? partnerHeaderSize.toLowerCase() : "standard",
    partnerCtaColor: checkValue(partnerCtaColor) ? partnerCtaColor : '',
    partnerHeaderPlaceholderText,
    partnerHeaderPlaceholderUrl,
    openPartnerUrlInSameTab: openPartnerUrlInSameTab === "True" ? true : false,
    partnerCtaTextColor,
    partnerCtaHoverColor,
    partnerCtaHoverTextColor,
    partnerHeaderNavigation,
    primaryColour,
    secondaryColour,
    subHeaderHamburgerMenuIconColor,
    subHeaderHamburgerMenuBackgroundColor,
    subHeaderHamburgerMenuTextColor,
    subHeaderHamburgerMenuBackgroundHoverColor,
    subHeaderHamburgerMenuTextHoverColor,
    subHeaderHamburgerMenuBackgroundSelectedColor,
    lozengeMessage,
    lozengeDetailMessage,
    lozengeTextColor,
    lozengeBackgroundColor,
    lozengeIconColor,
    turnOffHeader,
    turnOffSubheader,
    turnOffSubHeaderHamburgerMenu,
    };

  return (
    <MasterPage
      className="football-hub global-header-footer change-font-family"
      subHeaderProps={subHeaderProps}
      socialModule={socialModule}
    >
      <FootBallHome {...props} />
    </MasterPage>
  );
};

export default FootballHub;
